"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/testimonialSectionTwo.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSectionTwo46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient5.jpg" | "/Templates/Doccure/img/patients/patient6.jpg" | "/Templates/Doccure/img/patients/patient7.jpg" */
    src: string;
    /** Detected variants: "Daniel Scott" | "Sofia Doe" | "Lisa Labon" */
    span0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/blog/blog-img-1.png" | "/Templates/Doccure/img/blog/blog-img-2.png" | "/Templates/Doccure/img/blog/blog-img-3.png" */
    imageWithBasePath0Src: string;
    /** Detected variants: "How to Keep Your Pet Healthy All Year Round" | "The Ultimate Guide to Pet Nutrition and Diet" | "Building a Strong Bond with Your Pet Through Proper Care" */
    link0Text: ReactNode;
    /** Detected variants: "col-xl-4 col-md-6" */
    className?: string;
    /** Detected variants: "blog-item-six" */
    div0ClassName?: string;
    /** Detected variants: "blog-image" */
    div0ClassName2?: string;
    /** Detected variants: "post-author" */
    div0ClassName3?: string;
    /** Detected variants: "all_routes.doctorProfile1" */
    href?: string;
    /** Detected variants: "Post Author" */
    alt?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href?: string;
    /** Detected variants: "Post Image" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title line-clamp-2" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    link0Href2?: string;
};
export type HomeSixTestimonialSectionTwoGeneratedProps = {
    divDiv0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestimonialSectionTwo46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTwo46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestimonialSectionTwo46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTwo46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionTwo46sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestimonialSectionTwo46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "Latest Blogs" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Explore Our Latest" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Articles" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    testimonialSectionTwo46s: TestimonialSectionTwo46sItem[];
    testimonialSectionTwo46sItemWrapper?: (item: TestimonialSectionTwo46sItem, content: ReactNode) => ReactNode;
    testimonialSectionTwo46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionTwo46sLinkVisible?: boolean;
    testimonialSectionTwo46sLinkRenderer?: (item: TestimonialSectionTwo46sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionTwo46sImageVisible?: boolean;
    testimonialSectionTwo46sImageRenderer?: (item: TestimonialSectionTwo46sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionTwo46sH3Visible?: boolean;
    testimonialSectionTwo46sH3Renderer?: (item: TestimonialSectionTwo46sItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionTwo46sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TestimonialSectionTwo46sItem) => Partial<ComponentProps<typeof SmartLink>>);
    testimonialSectionTwo46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionTwo46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionTwo46sH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionTwo46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeSixTestimonialSectionTwoGenerated: FC<HomeSixTestimonialSectionTwoGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Latest Blogs",
    sectionDiv0Div0H20H2Text = "Explore Our Latest",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Articles",
    divDiv0Div0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Link0LinkProps,
    divDiv0Div0Link0ImageWithBasePath0ImageProps,
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    testimonialSectionTwo46s,
    testimonialSectionTwo46sItemWrapper,
    testimonialSectionTwo46sRenderer,
    testimonialSectionTwo46sLinkVisible,
    testimonialSectionTwo46sLinkRenderer,
    testimonialSectionTwo46sImageVisible,
    testimonialSectionTwo46sImageRenderer,
    testimonialSectionTwo46sH3Visible,
    testimonialSectionTwo46sH3Renderer,
    testimonialSectionTwo46sLinkProps,
    testimonialSectionTwo46sImageProps,
    testimonialSectionTwo46sH3Props,
}) => {
    return (
        <section className="article-section-six section">
            <div className="container">
                <div className="section-header-six text-center">
                    <div className="section-sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="line-6">{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-5"}>
                    {renderCollectionNode(
                        testimonialSectionTwo46s,
                        (item: TestimonialSectionTwo46sItem) => (
                            <div className={item.className ?? "col-xl-4 col-md-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-six"}>
                                    <div className={item.div0ClassName2 ?? "blog-image"}>
                                        {renderItemNode(testimonialSectionTwo46sLinkVisible, testimonialSectionTwo46sLinkRenderer, item, (
                                            <SmartLink href={item.link0Href ?? "all_routes.blogDetails"} {...(typeof testimonialSectionTwo46sLinkProps === "function" ? testimonialSectionTwo46sLinkProps(item) : (testimonialSectionTwo46sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>
                                                {renderItemNode(testimonialSectionTwo46sImageVisible, testimonialSectionTwo46sImageRenderer, item, (
                                                    <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "Post Image"} {...(typeof testimonialSectionTwo46sImageProps === "function" ? testimonialSectionTwo46sImageProps(item) : (testimonialSectionTwo46sImageProps ?? {}))} {...(typeof divDiv0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))}
                                        <div className={item.div0ClassName3 ?? "post-author"}>
                                            {renderItemNode(testimonialSectionTwo46sLinkVisible, testimonialSectionTwo46sLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "all_routes.doctorProfile1"} {...(typeof testimonialSectionTwo46sLinkProps === "function" ? testimonialSectionTwo46sLinkProps(item) : (testimonialSectionTwo46sLinkProps ?? {}))} {...(typeof divDiv0Div0Div0Link0LinkProps === "function" ? divDiv0Div0Div0Link0LinkProps(item) : (divDiv0Div0Div0Link0LinkProps ?? {}))}>
                                                    {renderItemNode(testimonialSectionTwo46sImageVisible, testimonialSectionTwo46sImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "Post Author"} {...(typeof testimonialSectionTwo46sImageProps === "function" ? testimonialSectionTwo46sImageProps(item) : (testimonialSectionTwo46sImageProps ?? {}))} {...(typeof divDiv0Div0Div0Link0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0Link0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0Link0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                    <span>{item.span0Text}</span>
                                                </SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        {renderItemNode(testimonialSectionTwo46sH3Visible, testimonialSectionTwo46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title line-clamp-2"} {...(typeof testimonialSectionTwo46sH3Props === "function" ? testimonialSectionTwo46sH3Props(item) : (testimonialSectionTwo46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(testimonialSectionTwo46sLinkVisible, testimonialSectionTwo46sLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href2 ?? "all_routes.blogDetails"} {...(typeof testimonialSectionTwo46sLinkProps === "function" ? testimonialSectionTwo46sLinkProps(item) : (testimonialSectionTwo46sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        testimonialSectionTwo46sItemWrapper,
                        testimonialSectionTwo46sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeSixTestimonialSectionTwoGenerated;
